/** Payroll / OGPI glossary for inline help tooltips. */
export const PAYROLL_GLOSSARY = {
  ogpi: {
    title: 'OGPI',
    text: 'Oracle Global Payroll Interface — sends Oracle HCM payroll data to ADP GlobalView.',
  },
  g2: {
    title: 'G2 file',
    text: 'ADP time file with hours by person and wage type. Required for time & labor reconciliation.',
  },
  ssl: {
    title: 'SSL',
    text: 'Wage-type load file staged for ADP intake before payroll processing.',
  },
  softWall: {
    title: 'Soft wall',
    text: 'Effective-date cutoff after which ADP blocks back-dated records from loading.',
  },
  wageType: {
    title: 'Wage type',
    text: 'ADP/SAP pay code equivalent to an Oracle payroll element.',
  },
  element: {
    title: 'Element entry',
    text: 'Oracle pay component and amount/hours for an employee in a pay period.',
  },
  register: {
    title: 'Payroll register',
    text: 'ADP output listing amounts and hours paid per employee and wage type.',
  },
  globalId: {
    title: 'Global ID',
    text: 'ADP person identifier used to match Oracle Person Number during reconciliation.',
  },
  infotype: {
    title: 'Infotype (IT)',
    text: 'SAP/GlobalView data grouping — e.g. IT0002 personal data, IT0009 bank details.',
  },
  bip: {
    title: 'BI Publisher (BIP)',
    text: 'Oracle reporting engine used to run Element Entries, Employee Master, and other catalog reports live.',
  },
  payPeriod: {
    title: 'Pay period',
    text: 'ADP payroll cycle identifier (for example 202610). Used to filter the register and label recon runs.',
  },
  personNumber: {
    title: 'Person number',
    text: 'Oracle employee identifier. Matched to ADP Global ID (or Client ID) during reconciliation.',
  },
  classification: {
    title: 'Classification',
    text: 'Oracle element grouping (earnings, deductions, employer charges) used to filter recon and reports.',
  },
  catalog: {
    title: 'Oracle report catalog',
    text: 'The Oracle folder where this app’s payroll reports are published — Employee Master, Element Entries, and related extracts.',
  },
  tolerance: {
    title: 'Tolerance',
    text: 'Allowed dollar, percent, or hours difference before a row is flagged as an exception.',
  },
  exception: {
    title: 'Exception',
    text: 'A row that fails a reconciliation rule and needs payroll review.',
  },
};

export function getGlossaryTerm(term) {
  return PAYROLL_GLOSSARY[term] || null;
}
